import api from './api';

// One request per page load for each list: every currency picker on a screen shares the same answer
// (the hotel form alone has four). A failed request is not kept, so the next picker retries.
const cache = {};

const currencyService = {
  // All active currencies, or only the billing ones with { billing: 'Y' } (V580)
  getCurrencies: (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.billing) params.append('billing', filters.billing);
    if (filters.includeInactive) params.append('includeInactive', filters.includeInactive);
    const url = `/currencies${params.toString() ? '?' + params.toString() : ''}`;

    if (!cache[url]) {
      cache[url] = api.get(url)
        .then(response => response.data.currencies || [])
        .catch(err => { delete cache[url]; throw err; });
    }
    return cache[url];
  },

  // Admin › Platform › Currencies: every code, inactive included, never cached.
  listAll: async () => (await api.get('/currencies?includeInactive=Y')).data.currencies || [],

  // Superadmin only (admin API). Either one drops the cache so pickers opened afterwards see the change.
  create: async (data) => {
    const res = await api.post('/admin/currencies', data);
    Object.keys(cache).forEach(k => delete cache[k]);
    return res.data;
  },
  update: async (code, data) => {
    const res = await api.put(`/admin/currencies/${code}`, data);
    Object.keys(cache).forEach(k => delete cache[k]);
    return res.data;
  }
};

export default currencyService;
